export type InfoVoucherAction =
  | { type: 'SET_IS_FETCHING_VOUCHER_CONTENT' }
  | { type: 'SET_FETCH_VOUCHER_CONTENT_FAILED' }
  | { type: 'SET_VOUCHER_CONTENT', content: Julius.Content.VoucherPage };

  export const setIsFetching = (): InfoVoucherAction => ({
    type: 'SET_IS_FETCHING_VOUCHER_CONTENT',
  });

  export const setFetchFailed = (): InfoVoucherAction => ({
    type: 'SET_FETCH_VOUCHER_CONTENT_FAILED',
  });

  export const setVoucherContent = (content: Julius.Content.VoucherPage): InfoVoucherAction => ({
    content,
    type: 'SET_VOUCHER_CONTENT',
  });


// WEBPACK FOOTER //
// ./src/pages/InfoVoucherPage/Redux/actions.tsx